import * as React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import { Button, CircularProgress } from "@material-ui/core";
import { ChevronLeft, ChevronRight } from "@material-ui/icons";

// internal
import { styles } from "./OnboardingButtons.styles";
import { IProps, IState } from "./OnboardingButtons.d";

class OnboardingButtonsComponent extends React.Component<IProps, IState> {
  static defaultProps = {
    backButtonLabel: "Back",
    onClickSkipButton: () => null,
    skipButtonHidden: true,
    skipButtonLabel: "Skip",
  };

  private allowButtonPressesTimeout: ReturnType<typeof setTimeout> | undefined;

  constructor(props: IProps) {
    super(props);

    this.state = {
      allowButtonPresses: false,
    };
  }

  public componentDidMount() {
    this.allowButtonPressesTimeout = setTimeout(
      () =>
        this.setState({
          allowButtonPresses: true,
        }),
      500,
    );
  }

  public componentWillUnmount() {
    if (this.allowButtonPressesTimeout) {
      clearTimeout(this.allowButtonPressesTimeout);
      delete this.allowButtonPressesTimeout;
    }
  }

  public render() {
    const {
      classes,
      backButtonLabel,
      backButtonDisabled,
      backButtonHidden,
      forwardButtonLabel,
      forwardButtonDisabled,
      forwardButtonHidden,
      forwardButtonLoading,
      skipButtonLabel,
      skipButtonHidden,
      skipButtonDisabled,
      onClickBackButton,
      onClickForwardButton,
      onClickSkipButton,
    } = this.props;

    const { allowButtonPresses } = this.state;

    return (
      <React.Fragment>
        {!backButtonHidden ? (
          <div className={`${classes.buttonContainer} left`}>
            <Button
              disabled={backButtonDisabled || !allowButtonPresses}
              onClick={onClickBackButton}
              className={`${classes.backButton}${
                !allowButtonPresses && !backButtonDisabled ? " loading" : ""
              }`}
            >
              <ChevronLeft />
              {backButtonLabel ? <span className="label">{backButtonLabel}</span> : null}
            </Button>
          </div>
        ) : null}
        {!forwardButtonHidden || !skipButtonHidden ? (
          <div className={`${classes.buttonContainer} right`}>
            {!skipButtonHidden ? (
              <Button
                disabled={skipButtonDisabled || !allowButtonPresses}
                onClick={onClickSkipButton}
                className={`${classes.skipButton}${
                  !allowButtonPresses && !skipButtonDisabled ? " loading" : ""
                }`}
              >
                <span className="label">{skipButtonLabel}</span>
                {!this.props.forwardButtonChevronHidden && forwardButtonHidden ? (
                  <ChevronRight />
                ) : null}
              </Button>
            ) : null}
            {!forwardButtonHidden ? (
              <Button
                disabled={forwardButtonDisabled || !allowButtonPresses}
                onClick={onClickForwardButton}
                className={`${classes.forwardButton}${!skipButtonHidden ? " skip-enabled" : ""}${
                  !allowButtonPresses && !forwardButtonDisabled ? " loading" : ""
                }`}
              >
                {forwardButtonLoading ? (
                  <CircularProgress size={24} style={{ marginRight: 4 }} />
                ) : null}
                {!forwardButtonLoading && forwardButtonLabel ? (
                  <span className="label">{forwardButtonLabel}</span>
                ) : null}
                {!forwardButtonLoading && !this.props.forwardButtonChevronHidden ? (
                  <ChevronRight />
                ) : null}
              </Button>
            ) : null}
          </div>
        ) : null}
      </React.Fragment>
    );
  }
}

export const OnboardingButtons = withStyles(styles)(OnboardingButtonsComponent);
